
// todo - should all of this be moved to external configuration (le-conf)?

define(function (require) {

    require.context(
        '!file-loader?name=[path][name].[ext]!./../../audio',
        false,
        /.*/
    );

    var lpAgentConfig = {
        // todo - is it still necessary to compose paths like that? probably not
        // htmlDir: win.leBaseUrl + "src/modules/web-agent/assets/templates",
        audioDir: (window.leResourceBaseUrl ? window.leResourceBaseUrl : '') + "src/modules/web-agent/assets/audio",
        lazyInitialization: true,
        actAsProduction: false,
        agentChatState: "Online",
        pollVisitInfoTimeout: 30000,
        // todo - activate this with 'true' only in dev mode
        throwExceptions: true,
    };

    return lpAgentConfig;

});
